import { React, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DotsHorizontalIcon } from "@heroicons/react/solid";
import "../CSS/LearnContent/LearnContent.css";
import { Markup } from "interweave";
import moment from "moment";
import ShowMoreText from "react-show-more-text";
import axios from "axios";
import swal from "sweetalert";

import noImage from "../../Assets/Images/no-image.png";

import PostReaction from "../../Screen/Post/PostReaction";
import { serverInfo } from "../../App";
import ReactPlayer from "react-player";


export default function GreetingContent({ post }) {


  const { imageCdnUrl ,videoCdnUrl} = useContext(serverInfo);

  const [open, setOpen] = useState(false);

  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });

  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };


  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={
                    post.star.image !== null
                      ? imageCdnUrl + post.star.image
                      : noImage
                  }
                  className="PostImgHome"
                  alt="star-profile"
                />
                <span className="mx-2 text-warning text-light">
                  <Link
                    to={`/starprofile/${post.user_id}`}
                    className="link-starPorfile"
                  >
                    {post.star?.first_name} {post.star?.last_name}
                  </Link>
                  <br></br>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LT")}
                    {" | "}
                  </small>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LL")}
                  </small>
                </span>
              </div>
            </div>
          </h2>

          <h5 className="my-2 Enroll-a Enroll-text text-justify">
            {post?.title}
          </h5>

          <ShowMoreText
            lines={3}
            more={<span>See more</span>}
            less={<span>See less</span>}
            className="content-css my-2 Enroll-a Enroll-text py-2"
            anchorClass="my-anchor-css-class"
            //onClick={executeOnClick}
            expanded={false}
            truncatedEndingComponent={"... "}
          >
            <Markup content={post?.details}></Markup>
          </ShowMoreText>

          <div className="ViewPost">
            <div className=" card  border-0 containerPost">
            {post?.video != null ? (
              <>
                <ReactPlayer
                  url={videoCdnUrl+post?.video}
                  controls={true}
                  playing={false}
                  volume={1}
                  className="Live-Video-x"
                  style={{ margin: "0 auto" }}
                />
              </>
            ) : (
              <>
                <img
                  src={
                    post?.banner !== null
                      ? imageCdnUrl+post?.banner
                      : noImage
                  }
                  alt={post?.banner}
                />
              </>
            )}
              <div className="centeredPost ">
                <div className="LeftTextPost col-md-8">
                  <div className=" text-light bottom-LeftPost text-start  fw-bold px-4 py-1">
                    Greetings
                  </div>
                </div>
                <div className="LeftTextPost col-md-4">

                  <Link
                    to={{
                      pathname: `starprofile/${post?.star_id}/greeting`,
                      state: { post: post },
                    }}
                    className="link-starPorfile"
                  >
                    {" "}
                    <button className="bottom-rightPost text-dark fw-bold AnimateBtn px-4 py-1">
                      <span className="pTd"> Register Now</span>
                    </button>
                  </Link>
               
                </div>
              </div>
              <div className="centeredPostV "></div>
            </div>

            <PostReaction post={post}></PostReaction>
          </div>
        </div>
      </div>
    </>
  );
}
